import { Box, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CriSection from "../../components/CriSection";
import { BEE_GALLERY, BeeGalleryType } from "../../constants/bee_gallery";
import { Key } from "react";

const BeeGallery = () => {
  const theme = useTheme();

  return (
    <CriSection alternate={true}>
      <Typography
        sx={{
          fontSize: "36px",
          fontWeight: 500,
          lineHeight: 1,
          textAlign: "center",
        }}
      >
        Gallery
      </Typography>

      <Grid
        container
        spacing={{ xs: 2, md: 4 }}
        sx={{
          marginTop: "36px",
        }}
      >
        {BEE_GALLERY.map(
          (beePhoto: BeeGalleryType, index: Key | null | undefined) => (
            <Grid size={{ xs: 6, md: 4 }} key={index}>
              <Box
                sx={{
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: "12px",
                  paddingBottom: "12px",
                }}
              >
                <img
                  src={beePhoto.image}
                  alt="Bee"
                  style={{
                    width: "100%",
                    height: "200px",
                    borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px",
                    objectFit: "cover",
                  }}
                />

                <Typography
                  sx={{
                    marginTop: "6px",
                    fontSize: "14px",
                    fontWeight: 400,
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  {beePhoto.name}
                </Typography>
              </Box>
            </Grid>
          )
        )}
      </Grid>
    </CriSection>
  );
};

export default BeeGallery;
